import { FC } from 'react';
import { DetailSectionProps } from './harmReports.type';

export const DetailSection: FC<DetailSectionProps> = (props) => {
  const columns = props.columns || 2;
  const flexBasis = `${100 / columns}%`;

  return (
    <div className={`flex flex-col sm:flex-row ${props.className || ''}`}>
      <div className="text-[#151740] text-sm font-semibold mb-2 sm:mb-0 sm:basis-[200px] shrink-0 whitespace-pre-line">
        {props.title}
      </div>
      <div className="flex flex-col sm:flex-row flex-1" style={{ gap: '1rem' }}>
        {Array.isArray(props.children) ? (
          props.children.map((child, index) => (
            <div
              key={index}
              style={{ flexBasis }}
              className="flex-shrink-0 mb-4 sm:mb-0"
            >
              {child}
            </div>
          ))
        ) : (
          <div style={{ flexBasis }} className="mb-4 sm:mb-0">
            {props.children}
          </div>
        )}
      </div>
    </div>
  );
};
